import React, {Component} from 'react';
import ContainerHeader from 'components/ContainerHeader';
import Paper from 'material-ui/Paper';
import {get} from 'engine/dataServices';
import ContractHtml from "../../../../../data/Contract.html";

const bankTypes = [
    {id: 0, name: 'accountNumber', faName: 'شماره حساب'},
    {id: 1, name: 'cardNumber', faName: 'شماره کارت'},
    {id: 2, name: 'shabaNumber', faName: 'شماره شبا'},
];

class Contract extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            firstName: '',
            lastName: '',
            producerName: '',
            phoneNumber: '',
            instagramId: '',
            address: '',
            bankName: '',
            accountNumber: '',
            bankType: ''
        };

        this.loadData();
    }

    async loadData() {
        const res = await get('Producer/GetContract');
        if (res.status == 200) {
            const data = await res.json();
            const bankAccount = data.Producer.BankAccount;

            let bankNumberTypeTxt = bankTypes.find(x => x.id == bankAccount.Type).faName;

            const _data = {
                firstName: data.FirstName,
                lastName: data.LastName,
                producerName: data.Producer.Name,
                instagramId: data.Producer.InstagramId,
                accountNumber: bankAccount.Value,
                bankName: bankAccount.BankName,
                bankType: bankNumberTypeTxt,
                address: data.Address.Address
            };

            this.setState(_data);
        }
    }

    render() {
        const {firstName, lastName, producerName, phoneNumber, instagramId, address, bankName, accountNumber, bankType} = this.state;

        const seriallized =
            ContractHtml
                .replace('##FullName##', `${firstName} ${lastName}`)
                .replace('##ProducerName##', producerName)
                .replace('##Address##', address)
                .replace('##InstagramId##', instagramId)
                .replace('##BankName##', bankName)
                .replace('##AccountNumber##', accountNumber)
                .replace('##BankType##', bankType)
                .replace('##PhoneNumber##', phoneNumber);

        const htmlDoc = {__html: seriallized};

        return (
            <div className="animated slideInUpTiny animation-duration-3">
                <ContainerHeader match={this.props.match} title="قرار داد"/>

                <Paper>
                    <div dangerouslySetInnerHTML={htmlDoc} style={{padding: 20, textAlign: 'justify'}}></div>
                </Paper>
            </div>
        )
    }
}

export default Contract



// WEBPACK FOOTER //
// ./app/routes/toliton/contract/contract.js